import uiToogleTransferReserves from './toogle-transfer-reserves/index.vue'
import uiToogleDebugMode from './toogle-debug-mode/index.vue'

export {
    uiToogleTransferReserves,
    uiToogleDebugMode
}

